export default __webpack_public_path__ + "static/media/banner_1.63c078ec.png";